import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { PrintCompilerErrorType } from '#src/types/PrintCompilerErrorType'

export default class PrintCompilerError extends BaseError<PrintCompilerErrorType> {
  constructor(
    public message: string,
    public code: PrintCompilerErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, PrintCompilerError.prototype)
    this.name = this.constructor.name
  }
}
